import {
    InvoiceFilters,
    InvoiceFiltersSchema,
} from "@common/contracts/invoice.contract";
import { omit } from "@common/helpers/objects";
import {
    useWorkspaceUserCache,
    WORKSPACE_USER_CACHE_KEYS,
} from "../useWorkspaceUserCache";

const INVOICE_SESSION_FILTER_KEYS = [
    "ids",
    "search",
    "hasOpenAmount",
] as const satisfies ReadonlyArray<keyof InvoiceFilters>;

const sanitizeFilters = (
    filters: InvoiceFilters | undefined,
): InvoiceFilters | undefined => {
    if (!filters) {
        return undefined;
    }

    const persisted = omit(filters, [...INVOICE_SESSION_FILTER_KEYS]);
    if (!persisted.catalogItemIds || persisted.catalogItemIds.length === 0) {
        return omit(persisted, ["catalogItemFilterType"]);
    }

    return persisted;
};

export function useInvoicesPageFiltersCache(): [
    InvoiceFilters | undefined,
    (value: InvoiceFilters | undefined) => void,
] {
    const [value, setter] = useWorkspaceUserCache<InvoiceFilters>(
        WORKSPACE_USER_CACHE_KEYS.INVOICES_PAGE_FILTERS_CACHE_KEY,
        InvoiceFiltersSchema,
    );

    return [
        value,
        (filters: InvoiceFilters | undefined) => {
            setter(sanitizeFilters(filters));
        },
    ];
}
